import { render, staticRenderFns } from "./CustomersConfiguration.vue?vue&type=template&id=6f7feabc&"
import script from "./CustomersConfiguration.vue?vue&type=script&lang=js&"
export * from "./CustomersConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports